/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Alert_TextInputs */



/**
* | output |
* | --- |
* | "Select the level of shot change detection" |
*
* @param {Scene_Change_Detection_Alert_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_alert_text = /** @type {((inputs?: Scene_Change_Detection_Alert_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Alert_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez le niveau de detection de changement de plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Stufe der Schusswechselerkennung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il livello di rilevamento del cambio di scatto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите уровень обнаружения смены кадра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el nivel de detección de cambios de disparo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择投篮变化检测级别")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショットチェンジ検出のレベルを選択する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट परिवर्तन पहचान का स्तर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o nível de detecção de mudança de tiro.")
	return /** @type {LocalizedString} */ ("Select the level of shot change detection")
});